import React from 'react'
import axios from 'axios';
import Swal from 'sweetalert2';
import LoadHospital from './LoadData/LoadHospital';
import Loading from '../../Components/Loading/LoadingCenterPage';
import {
  ShieldCheckIcon,
  XCircleIcon,
  ArrowPathIcon,
  InformationCircleIcon,
  MagnifyingGlassIcon,
  FunnelIcon,
  UserCircleIcon,
  PhoneIcon,
  EnvelopeIcon,
  IdentificationIcon,
  BriefcaseIcon,
  CalendarDaysIcon,
  BuildingOfficeIcon
} from '@heroicons/react/24/outline';
import { Chip, Autocomplete, TextField, Box, Paper, IconButton, Tooltip } from '@mui/material';

const HealthInsurance = () => {

  const [token] = React.useState(localStorage.getItem("token"));
  const [dataReadGoogle, setDataReadGoogle] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [filterStatus, setFilterStatus] = React.useState('ทั้งหมด');
  const [filterPlan, setFilterPlan] = React.useState('ทั้งหมด');
  const [filterEmploymentType, setFilterEmploymentType] = React.useState('ทั้งหมด');
  const hosptal = LoadHospital()

  const getDataReadGoogle = async () => {
    fetch('https://script.google.com/macros/s/AKfycbySLOK6qQX5lWmDzdnxqiIP_g1pmY5FnWuyGY0zGGJQVMWV7WDJzcGvfFqoktamqic/exec', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        action: "read",
      })
    })
      .then(response => response.json())
      .then((res) => {
        setDataReadGoogle(res.data.filter(v => v.cancel !== "Yes"));
      })
      .catch(error => console.error('Error!', error.message));
  }
  
  React.useEffect(() => {
    if (dataReadGoogle === null) {
      getDataReadGoogle()
    };
  }, [dataReadGoogle]);

  const getData = React.useCallback(() => {
    axios({
      method: 'get',
      url: `https://www.phoenix-md.com/api/personnel/employee/read?not="แพทย์"`,
      params: "",
      headers: {
        "Content-Type": "application/json",
        Authorization: token
      }
    }).then((res) => {
      if (!!res.data.results) {
        setData(res.data.results);
      }
    }).catch((error) => {
      console.log(error.message);
    });
  }, [token, setData]);
  
  React.useEffect(() => {
    if (data === null) {
      getData()
    };
  }, [getData, data]);

  // Filter data
  const filteredDataReadGoogle = React.useMemo(() => {
    if (!dataReadGoogle || !data) return [];
    
    return dataReadGoogle.filter(v => {
      const find_employee = data?.find(f => f.pid === v.pid);
      const isInvalid = !find_employee?.pid;
      const isWarning = find_employee?.employmentType === "Part-Time" ||
        (find_employee?.firstDayOfWork &&
          (new Date().getTime() - new Date(find_employee.firstDayOfWork).getTime()) <
          365 * 24 * 60 * 60 * 1000);
      
      if (filterStatus !== 'ทั้งหมด') {
        if (filterStatus === 'ไม่พบข้อมูล' && !isInvalid) return false;
        if (filterStatus === 'ตรวจสอบ' && !isWarning) return false;
        if (filterStatus === 'ปกติ' && (isInvalid || isWarning)) return false;
      }
      
      if (filterPlan !== 'ทั้งหมด') {
        if (filterPlan === 'แผน 1' && v.plan !== '1') return false;
        if (filterPlan === 'แผน 2' && v.plan !== '2') return false;
        if (filterPlan === 'ไม่ได้เลือก' && v.plan) return false;
      }
      
      if (filterEmploymentType !== 'ทั้งหมด') {
        if (!find_employee) return false;
        if (find_employee.employmentType !== filterEmploymentType) return false;
      }
      
      return true;
    });
  }, [dataReadGoogle, data, filterStatus, filterPlan, filterEmploymentType]);

  const handleCancel = (name, id) => {
    const date = new Date("2025-08-10");
    const formatted = new Intl.DateTimeFormat("th-TH-u-ca-gregory", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    }).format(date);

    Swal.fire({
      title: "ยืนยันยกเลิกส่งประกัน",
      text: name,
      icon: 'warning',
      showDenyButton: true,
      confirmButtonText: "ตกลง",
      denyButtonText: `ยกเลิก`,
    }).then((result) => {
      if (result.isConfirmed) {
        fetch('https://script.google.com/macros/s/AKfycbySLOK6qQX5lWmDzdnxqiIP_g1pmY5FnWuyGY0zGGJQVMWV7WDJzcGvfFqoktamqic/exec', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            action: "update",
            id: id,
            cancel: "Yes",
            cancelDate: formatted
          })
        })
          .then(response => response.json())
          .then(() => {
            Swal.fire({
              title: 'สำเร็จ!!',
              icon: 'success',
              confirmButtonText: 'ตกลง',
            }).then((result) => {
              if (result.isConfirmed) {
                getDataReadGoogle();
                getData();
              }
            });
          }).catch(error => console.error('Error!', error.message));
      }
    });
  }

  const handleAddPlan = (name, id) => {
    Swal.fire({
      title: "เลือกแผนประกัน",
      input: "select",
      inputOptions: {
        1: "แผน 1",
        2: "แผน 2"
      },
      inputPlaceholder: "กรุณาเลือกแผน",
      showCancelButton: true,
      confirmButtonText: "ตกลง",
      cancelButtonText: "ยกเลิก",
    }).then((result) => {
      if (result.isConfirmed) {
        const selectedPlan = result.value;
        fetch('https://script.google.com/macros/s/AKfycbySLOK6qQX5lWmDzdnxqiIP_g1pmY5FnWuyGY0zGGJQVMWV7WDJzcGvfFqoktamqic/exec', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({
            action: "update",
            plan: selectedPlan,
            id: id,
          })
        })
          .then(response => response.json())
          .then(() => {
            Swal.fire({
              title: 'สำเร็จ!!',
              icon: 'success',
              confirmButtonText: 'ตกลง',
            }).then((result) => {
              if (result.isConfirmed) {
                getDataReadGoogle();
              }
            });
          }).catch(error => console.error('Error!', error.message));
      }
    });
  }

  const date = (value) => {
    return new Date(value).toLocaleString('th-TH', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }
  
  function calculateAge(birthDateStr) {
    const birthDate = new Date(birthDateStr);
    const today = new Date();

    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years} ปี ${months} เดือน`;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-8">
      <div className="max-w-[1800px] mx-auto">
        
        {/* Header Section */}
        <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6 md:p-8 mb-6">
          <div className="flex items-center gap-4 mb-2">
            <div className="p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl shadow-lg">
              <ShieldCheckIcon className="h-8 w-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-black text-gray-900 tracking-tight">รายงานประกัน AIA</h1>
              <p className="text-sm text-gray-500 mt-1">ระบบจัดการข้อมูลประกันสุขภาพพนักงาน</p>
            </div>
          </div>

          {/* Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-4 border border-blue-200">
              <div className="flex items-center gap-3">
                <InformationCircleIcon className="h-6 w-6 text-blue-600" />
                <div>
                  <p className="text-xs text-blue-600 font-semibold uppercase">พนักงานทั้งหมด</p>
                  <p className="text-2xl font-black text-blue-900">{dataReadGoogle?.length || 0}</p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-4 border border-green-200">
              <div className="flex items-center gap-3">
                <ShieldCheckIcon className="h-6 w-6 text-green-600" />
                <div>
                  <p className="text-xs text-green-600 font-semibold uppercase">มีสิทธิ์ประกัน</p>
                  <p className="text-2xl font-black text-green-900">
                    {dataReadGoogle?.filter(v => {
                      const find_employee = data?.find(f => f.pid === v.pid);
                      return find_employee?.pid && find_employee?.employmentType !== "Part-Time";
                    }).length || 0}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-2xl p-4 border border-amber-200">
              <div className="flex items-center gap-3">
                <XCircleIcon className="h-6 w-6 text-amber-600" />
                <div>
                  <p className="text-xs text-amber-600 font-semibold uppercase">ต้องตรวจสอบ</p>
                  <p className="text-2xl font-black text-amber-900">
                    {dataReadGoogle?.filter(v => {
                      const find_employee = data?.find(f => f.pid === v.pid);
                      return !find_employee?.pid || find_employee?.employmentType === "Part-Time";
                    }).length || 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <Paper sx={{ p: 3, mb: 4, borderRadius: 4, boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#64748B', mb: 2 }}>
            <FunnelIcon style={{ width: 20 }} />
            <span style={{ fontSize: 14, fontWeight: 700 }}>ตัวกรองข้อมูล:</span>
          </Box>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Autocomplete
              options={['ทั้งหมด', 'ไม่พบข้อมูล', 'ตรวจสอบ', 'ปกติ']}
              value={filterStatus}
              onChange={(e, newValue) => setFilterStatus(newValue || 'ทั้งหมด')}
              size="small"
              renderInput={(params) => <TextField {...params} label="สถานะ" variant="outlined" />}
            />
            <Autocomplete
              options={['ทั้งหมด', 'แผน 1', 'แผน 2', 'ไม่ได้เลือก']}
              value={filterPlan}
              onChange={(e, newValue) => setFilterPlan(newValue || 'ทั้งหมด')}
              size="small"
              renderInput={(params) => <TextField {...params} label="แผนประกัน" variant="outlined" />}
            />
            <Autocomplete
              options={['ทั้งหมด', 'Full-Time', 'Part-Time']}
              value={filterEmploymentType}
              onChange={(e, newValue) => setFilterEmploymentType(newValue || 'ทั้งหมด')}
              size="small"
              renderInput={(params) => <TextField {...params} label="ประเภทการจ้าง" variant="outlined" />}
            />
          </div>
          <div className="mt-3 flex items-center gap-2">
            <MagnifyingGlassIcon className="h-4 w-4 text-gray-400" />
            <span className="text-xs text-gray-500">
              แสดง {filteredDataReadGoogle.length} จาก {dataReadGoogle?.length || 0} รายการ
            </span>
          </div>
        </Paper>

        {/* Cards Grid */}
        {dataReadGoogle && data ? (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {filteredDataReadGoogle.map((v, i) => {
              const find_employee = data?.find(f => f.pid === v.pid);
              const isInvalid = !find_employee?.pid;
              const isWarning = find_employee?.employmentType === "Part-Time" ||
                (find_employee?.firstDayOfWork &&
                  (new Date().getTime() - new Date(find_employee.firstDayOfWork).getTime()) <
                  365 * 24 * 60 * 60 * 1000);

              const canCancel = !find_employee?.pid ||
                find_employee?.employmentType === "Part-Time" ||
                (find_employee?.firstDayOfWork &&
                  (Date.now() - new Date(find_employee.firstDayOfWork).getTime()) <
                  365 * 24 * 60 * 60 * 1000) ||
                (!find_employee?.consentEmployee ||
                  Object.keys(find_employee.consentEmployee).length === 0) ||
                (find_employee?.consentEmployee && (() => {
                  const threeMonths = 90 * 24 * 60 * 60 * 1000;
                  const firstConsent = Object.values(find_employee.consentEmployee)[0];
                  if (!firstConsent?.transactionDate) return false;
                  const dt = new Date(
                    String(firstConsent.transactionDate).replace(" ", "T")
                  ).getTime();
                  return Date.now() - dt > threeMonths;
                })());

              return (
                <div 
                  key={i} 
                  className={`rounded-2xl shadow-sm border p-6 hover:shadow-md transition-shadow ${
                    isInvalid ? 'bg-red-50 border-red-200' : 
                    isWarning ? 'bg-amber-50 border-amber-200' : 
                    'bg-white border-gray-200'
                  }`}
                >
                  {/* Header */}
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                        {find_employee?.label ? find_employee.label.charAt(0) : v.name.charAt(0)}
                      </div>
                      <div>
                        <h3 className="text-lg font-bold text-gray-900">
                          {find_employee ? find_employee.label : v.name}
                        </h3>
                        <div className="flex items-center gap-2 mt-1">
                          {isInvalid ? (
                            <Chip label="ไม่พบข้อมูล" size="small" sx={{ bgcolor: '#EF4444', color: 'white', fontWeight: 700, fontSize: 10, height: 20 }} />
                          ) : isWarning ? (
                            <Chip label="ตรวจสอบ" size="small" sx={{ bgcolor: '#F59E0B', color: 'white', fontWeight: 700, fontSize: 10, height: 20 }} />
                          ) : (
                            <Chip label="ปกติ" size="small" sx={{ bgcolor: '#10B981', color: 'white', fontWeight: 700, fontSize: 10, height: 20 }} />
                          )}
                          {find_employee && (
                            <Chip
                              label={find_employee.employmentType}
                              size="small"
                              sx={{
                                bgcolor: find_employee.employmentType === 'Part-Time' ? '#FEF3C7' : '#DBEAFE',
                                color: find_employee.employmentType === 'Part-Time' ? '#92400E' : '#1E40AF',
                                fontWeight: 700,
                                fontSize: 10,
                                height: 20
                              }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    {canCancel && (
                      <Tooltip title="ยกเลิกส่งประกัน">
                        <IconButton
                          onClick={() => handleCancel(find_employee?.label || v.name, v.id)}
                          sx={{ bgcolor: '#FEF2F2', '&:hover': { bgcolor: '#FEE2E2' } }}
                          size="small"
                        >
                          <XCircleIcon className="h-5 w-5 text-red-600" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>

                  {/* Info Grid */}
                  <div className="space-y-3 mb-4">
                    <div className="flex items-start gap-2">
                      <IdentificationIcon className="h-5 w-5 text-gray-600 flex-shrink-0 mt-0.5" />
                      <div className="flex-1">
                        <p className="text-xs text-gray-500 font-semibold uppercase">เลขบัตรประชาชน</p>
                        <p className="text-sm font-mono font-bold text-gray-900 mt-0.5">
                          {find_employee?.pid || <span className="text-red-500">ไม่พบข้อมูล</span>}
                        </p>
                      </div>
                      {find_employee?.sex && (
                        <Chip
                          label={find_employee.sex}
                          size="small"
                          sx={{
                            bgcolor: find_employee.sex === 'ชาย' ? '#DBEAFE' : '#FCE7F3',
                            color: find_employee.sex === 'ชาย' ? '#1E40AF' : '#BE185D',
                            fontWeight: 700,
                            fontSize: 10
                          }}
                        />
                      )}
                    </div>

                    <div className="flex items-start gap-2">
                      <BriefcaseIcon className="h-5 w-5 text-indigo-600 flex-shrink-0 mt-0.5" />
                      <div className="flex-1">
                        <p className="text-xs text-gray-500 font-semibold uppercase">ตำแหน่ง</p>
                        <p className="text-sm font-bold text-gray-900 mt-0.5">{find_employee?.positionJob || "-"}</p>
                      </div>
                    </div>

                    <div className="flex items-start gap-2">
                      <BuildingOfficeIcon className="h-5 w-5 text-purple-600 flex-shrink-0 mt-0.5" />
                      <div className="flex-1">
                        <p className="text-xs text-gray-500 font-semibold uppercase">สถานที่ทำงาน</p>
                        <div className="mt-1 flex flex-wrap gap-1">
                          {find_employee?.consentEmployee && Object.keys(find_employee.consentEmployee).length > 0 ? (
                            Object.entries(find_employee.consentEmployee).map(([hcode, c]) => (
                              <Chip
                                key={hcode}
                                label={hosptal?.find(h => h.hcode === hcode)?.hname}
                                size="small"
                                sx={{ bgcolor: '#E0E7FF', color: '#4338CA', fontWeight: 600, fontSize: 10 }}
                              />
                            ))
                          ) : (
                            <Chip label="ไม่พบที่ทำงาน" size="small" sx={{ bgcolor: '#FEE2E2', color: '#DC2626', fontWeight: 700, fontSize: 10 }} />
                          )}
                        </div>
                      </div>
                    </div>

                    {find_employee?.firstDayOfWork && (
                      <div className="flex items-start gap-2">
                        <CalendarDaysIcon className="h-5 w-5 text-green-600 flex-shrink-0 mt-0.5" />
                        <div className="flex-1">
                          <p className="text-xs text-gray-500 font-semibold uppercase">วันที่เริ่มงาน</p>
                          <p className="text-sm font-semibold text-green-700 mt-0.5">
                            {date(find_employee.firstDayOfWork)} ({calculateAge(find_employee.firstDayOfWork)})
                          </p>
                        </div>
                      </div>
                    )}

                    <div className="grid grid-cols-2 gap-3">
                      <div className="flex items-start gap-2">
                        <PhoneIcon className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
                        <div className="flex-1">
                          <p className="text-xs text-gray-500 font-semibold uppercase">เบอร์โทร</p>
                          <p className="text-sm font-mono font-semibold text-gray-900 mt-0.5">{find_employee?.phone || "-"}</p>
                        </div>
                      </div>
                      <div className="flex items-start gap-2">
                        <EnvelopeIcon className="h-5 w-5 text-orange-600 flex-shrink-0 mt-0.5" />
                        <div className="flex-1">
                          <p className="text-xs text-gray-500 font-semibold uppercase">อีเมล</p>
                          <p className="text-xs text-gray-700 mt-0.5 truncate">{find_employee?.emailNurse || "-"}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Plan Section */}
                  <div className="border-t border-gray-200 pt-4">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-xs text-gray-500 font-semibold uppercase mb-1">แผนประกัน</p>
                        {find_employee?.pid && v.plan !== "2" ? (
                          <Chip
                            label={v.plan || "ไม่ได้เลือก"}
                            size="small"
                            sx={{ bgcolor: '#FEE2E2', color: '#DC2626', fontWeight: 700 }}
                          />
                        ) : (
                          <Chip
                            label={`แผน ${v.plan}`}
                            size="small"
                            sx={{ bgcolor: '#D1FAE5', color: '#065F46', fontWeight: 700 }}
                          />
                        )}
                      </div>
                      {find_employee?.pid && v.plan !== "2" && (
                        <Tooltip title="เปลี่ยนแผน">
                          <IconButton
                            onClick={() => handleAddPlan(find_employee?.label || v.name, v.id)}
                            sx={{ bgcolor: '#EEF2FF', '&:hover': { bgcolor: '#E0E7FF' } }}
                          >
                            <ArrowPathIcon className="h-5 w-5 text-indigo-600" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <Loading />
        )}
      </div>
    </div>
  );
}

export default HealthInsurance
